module.exports = __webpack_public_path__ + "static/victaulic-logo-aaa696c002e61cc53c12fef943c98cf1.png";